import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenService } from '@auth';
import { SelectEvent } from '@progress/kendo-angular-layout';
import { Tab } from '@shared';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss',
})
export class ReportsComponent implements OnInit {
  constructor(
    private tokenService: TokenService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  tabs: Tab[] = [];

  isAdminUser: boolean = false;

  async ngOnInit() {
    this.isAdminUser = await this.tokenService.isAdmin();
    const isAvailabilityOnly = await this.tokenService.isAvailabilityOnly();

    this.tabs = [
      ...(this.isAdminUser
        ? [new Tab('Failure History', 'failures', true)]
        : [
            // Hide Tier Audit and Exceptions & Rules for AvailabilityOnly users
            ...(isAvailabilityOnly
              ? [
                  new Tab('Sync Exceptions', 'sync-exceptions', true),
                  new Tab('History', 'history-summary'),
                ]
              : [
                  new Tab(
                    'Exceptions & Rules',
                    'exceptions/delivery/negative',
                    true,
                  ),
                  new Tab('Sync Exceptions', 'sync-exceptions'),
                  new Tab('Tier Audit', 'audit'),
                  new Tab('History', 'history-summary'),
                ]),
          ]),
    ];
    const currentRoute =
      this.activatedRoute.snapshot.firstChild?.routeConfig?.path;
    const selectedTab = this.tabs.find(
      (tab) => tab.contentUrl === currentRoute,
    );
    if (selectedTab) {
      this.selectTab(selectedTab);
    }
  }

  selectTab(selectedTab: Tab) {
    this.tabs.forEach((tab) => {
      tab.selected = tab.name === selectedTab.name;
    });

    this.router.navigate([selectedTab?.contentUrl], {
      relativeTo: this.activatedRoute,
    });
  }

  onTabSelect(event: SelectEvent) {
    const selectedTab = this.tabs.find((tab) => tab.name === event?.title);
    if (selectedTab) this.selectTab(selectedTab);
  }
}
